export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-breadcrumbs/index.ts